import reports from '@/api/reports'
import moment from 'moment'

export default {
  namespaced: true,

  actions: {
    generateReport ({ dispatch, rootState }, params) {
      const dateFrom = moment(`${params.startDate} ${params.startTime}:00`).format('YYYY-MM-DDTHH:mm:ss')
      const dateTo = moment(`${params.endDate} ${params.endTime}:59`).format('YYYY-MM-DDTHH:mm:ss')
      const user = params.user
      const filters = {}

      const apiParams = { dateFrom, dateTo, user, filters }
      if (params.electronicDevice) {
        apiParams.electronicDevice = params.electronicDevice
      } else {
        apiParams.businessUnit = rootState.businessUnits.currentBusinessUnit.id
      }
      if (params.category) {
        filters.category = params.category
      }
      if (params.group) {
        filters.group = params.group
      }

      return new Promise((resolve, reject) => {
        if (params.type === 'DAILY') {
          dispatch('daily_sell_report', apiParams)
            .then(response => resolve(response))
            .catch(error => reject(error))
        } else if (params.type === 'USERS') {
          if (params.user) {
            apiParams.user = params.user.id
          }
          dispatch('user', apiParams)
            .then(response => resolve(response))
            .catch(error => reject(error))
        } else if (params.type === 'ARTICLES') {
          if (params.subtype === 'ARTICLES') {
            dispatch('article', apiParams)
              .then(response => resolve(response))
              .catch(error => reject(error))
          } else if (params.subtype === 'CATEGORIES') {
            apiParams.includeArticles = false
            dispatch('category', apiParams)
              .then(response => resolve(response))
              .catch(error => reject(error))
          } else if (params.subtype === 'BOTH') {
            apiParams.includeArticles = true
            dispatch('category', apiParams)
              .then(response => resolve(response))
              .catch(error => reject(error))
          } else {

          }
        } else {

        }
      })
    },
    user ({ rootState }, apiParams) {
      return new Promise((resolve, reject) => {
        reports.user(apiParams)
          .then(response => {
            const report = response.data.items
            resolve(parseUserReport(report))
          })
          .catch(error => reject(error))
      })
    },
    article ({ rootState }, apiParams) {
      return new Promise((resolve, reject) => {
        reports.article(apiParams)
          .then(response => {
            const report = response.data.items
            resolve(parseArticleReport(report))
          })
          .catch(error => reject(error))
      })
    },
    category ({ rootState }, apiParams) {
      return new Promise((resolve, reject) => {
        reports.category(apiParams)
          .then(response => {
            let report = response.data.items
            if (apiParams.includeArticles) {
              report = parseCategoryArticlesReport(report)
            } else {
              report = parseCategoryReport(report)
            }
            resolve(report)
          })
          .catch(error => reject(error))
      })
    },
    daily_sell_report ({ rootState }, apiParams) {
      return new Promise((resolve, reject) => {
        reports.daily_sell_report(apiParams)
          .then(response => {
            const report = response.data.items.map(item => {
              return parseDailyReport(item)
            })
            resolve(report)
          })
          .catch(error => reject(error))
      })
    },
    daily_sell_report_pdf ({ rootState }, apiParams) {
      return new Promise((resolve, reject) => {
        reports.daily_sell_report_pdf(apiParams)
          .then(response => {
            resolve(response.data.items[0])
          })
          .catch(error => reject(error))
      })
    }
  }
}

const parseUserReport = report => {
  const newReport = report.map(user => {
    // user.total *= 100
    user.paymentMethods = parsePaymentMethods(user.payment_methods)
    return user
  })
  return newReport
}

const parseArticleReport = report => {
  const newReport = report.map(article => {
    // article.sum *= 100
    return article
  })
  return newReport
}

const parseCategoryReport = report => {
  const newReport = report.map(cat => {
    // cat.sum *= 100
    return cat
  })
  return newReport
}

const parseCategoryArticlesReport = report => {
  const newReport = report.map(cat => {
    // cat.sum *= 100
    cat.articles = cat.articles.map(article => {
      // article.sum *= 100
      return article
    })
    return cat
  })
  return newReport
}

const parseDailyReport = report => {
  report.daily = report.daily.map(day => {
    day.minInvoiceNumber = day.min_invoice_number
    day.maxInvoiceNumber = day.max_invoice_number
    day.totalDiscount = day.total_discount //* 100
    day.totalSum = day.total_sum //* 100
    day.paymentMethods = parsePaymentMethods(day.payment_methods)
    day.taxGroups = parseTaxGroups(day.tax_groups)
    return day
  })

  report.totals.priceSum = report.totals.price_sum //* 100
  report.totals.discountSum = report.totals.discount_sum //* 100
  report.totals.taxGroups = parseTaxGroups(report.totals.tax_groups)
  report.totals.endBuyers = {
    paymentMethods: parsePaymentMethods(report.totals.natural_persons.payment_methods),
    taxGroups: parseTaxGroups(report.totals.natural_persons.tax_groups)
  }
  report.totals.clients = {
    paymentMethods: parsePaymentMethods(report.totals.legal_entities.payment_methods),
    taxGroups: parseTaxGroups(report.totals.legal_entities.tax_groups)
  }
  return report
}

const parseTaxGroups = taxGroups => {
  return {
    taxLevels: taxGroups.tax_levels.map(level => {
      // level.taxable_amount *= 100
      // level.tax_amount *= 100
      return level
    }),
    taxable_amount_total: taxGroups.taxable_amount_total, //* 100,
    tax_amount_total: taxGroups.tax_amount_total //* 100
  }
}

const parsePaymentMethods = paymentMethods => {
  return paymentMethods.map(method => {
    // method.total *= 100
    // method.sum *= 100
    return method
  })
}
